<template>
  <div class="timesheet-summary">
    <section class="timesheet-summary__section">
      <div class="text-subtitle-2 ncrm-text-strong">{{ $t("employeeDetails.timesheet.automaticSectionTitle") }}</div>
      <div class="info-row">
        <div class="info-row__label">
          <v-icon size="16" class="mr-2">mdi-clock-check-outline</v-icon>
          <strong>{{ $t("employeeDetails.timesheet.switchLabel") }}:</strong>
        </div>
        <v-chip class="timesheet-summary__chip" size="x-small" :color="settings.use_automatic ? 'success' : 'neutral'">
          {{ statusLabel(settings.use_automatic) }}
        </v-chip>
      </div>
      <div class="info-row">
        <div class="info-row__label">
          <v-icon size="16" class="mr-2">mdi-clock-outline</v-icon>
          <strong>{{ $t("employeeDetails.timesheet.schedule") }}:</strong>
        </div>
        <span class="timesheet-summary__value">{{ range(settings.workday_start, settings.workday_end) }}</span>
      </div>
      <div class="info-row">
        <div class="info-row__label">
          <v-icon size="16" class="mr-2">mdi-coffee-outline</v-icon>
          <strong>{{ $t("employeeDetails.timesheet.breakTime") }}:</strong>
        </div>
        <span class="timesheet-summary__value">{{ range(settings.break_start, settings.break_end) }}</span>
      </div>
    </section>

    <v-divider></v-divider>

    <section class="timesheet-summary__section">
      <div class="text-subtitle-2 ncrm-text-strong">{{ $t("employeeDetails.timesheet.smartTracker.title") }}</div>
      <div class="info-row">
        <div class="info-row__label">
          <v-icon size="16" class="mr-2">mdi-radar</v-icon>
          <strong>{{ $t("employeeDetails.timesheet.smartTracker.statusLabel") }}:</strong>
        </div>
        <v-chip class="timesheet-summary__chip" size="x-small" :color="settings.smart_tracker_enabled ? 'success' : 'neutral'">
          {{ statusLabel(settings.smart_tracker_enabled) }}
        </v-chip>
      </div>
      <!-- Smart Tracker oprit: restul parametrilor nu au sens, deci nu se afișează. -->
      <template v-if="settings.smart_tracker_enabled">
      <div class="info-row">
        <div class="info-row__label">
          <v-icon size="16" class="mr-2">mdi-timer-sand</v-icon>
          <strong>{{ $t("employeeDetails.timesheet.smartTracker.idleMinutes") }}:</strong>
        </div>
        <span class="timesheet-summary__value">{{ idleMinutes }} {{ $t("employeeDetails.timesheet.smartTracker.minutesSuffix") }}</span>
      </div>
      <div class="info-row">
        <div class="info-row__label">
          <v-icon size="16" class="mr-2">mdi-timer-outline</v-icon>
          <strong>{{ $t("employeeDetails.timesheet.smartTracker.promptMinutes") }}:</strong>
        </div>
        <span class="timesheet-summary__value">{{ promptMinutes }} {{ $t("employeeDetails.timesheet.smartTracker.minutesSuffix") }}</span>
      </div>
      <div class="info-row">
        <div class="info-row__label">
          <v-icon size="16" class="mr-2">mdi-tag-outline</v-icon>
          <strong>{{ $t("employeeDetails.timesheet.smartTracker.autoLabelStatus") }}:</strong>
        </div>
        <v-chip class="timesheet-summary__chip" size="x-small" :color="settings.smart_tracker_auto_label_enabled ? 'success' : 'neutral'">
          {{ statusLabel(settings.smart_tracker_auto_label_enabled) }}
        </v-chip>
      </div>
      </template>
    </section>
  </div>
</template>

<script>
// Rezumat read-only al setărilor de pontaj / Smart Tracker; editarea se face în drawerul din EmployeeDetails.
export default {
  name: "EmployeeTimesheetSettingsSummary",
  props: {
    settings: { type: Object, required: true },
    idleMinutes: { type: Number, default: 0 },
    promptMinutes: { type: Number, default: 0 },
  },
  methods: {
    range(start, end) {
      return start && end ? `${start} – ${end}` : "—";
    },
    statusLabel(active) {
      return this.$t(active ? "employeeDetails.hero.active" : "employeeDetails.hero.inactive");
    },
  },
};
</script>

<style scoped>
.timesheet-summary {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.timesheet-summary__section {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.info-row {
  display: flex;
  flex-direction: column;
  gap: 2px;
  font-size: 14px;
  color: rgba(var(--v-theme-on-surface), 0.80);
}
.info-row__label {
  display: flex;
  align-items: center;
}
.timesheet-summary__chip {
  align-self: flex-start;
  margin-left: 24px;
}
.timesheet-summary__value {
  margin-left: 24px;
  font-variant-numeric: tabular-nums;
}
</style>
